// permissions.js

/**
 * Canonical permission keys used by authUtils.hasPermission and
 * referenced from menu definitions (menuItems.js) via `requiredPermission`.
 * Using constants avoids typos and keeps allowed values discoverable.
 */
export const PERMISSIONS = Object.freeze({
  CREATE_LOANS: "CREATE_LOANS",
  LOCK_LOANS: "LOCK_LOANS",
  VIEW_PRICING: "VIEW_PRICING",
  VIEW_PIPELINE: "VIEW_PIPELINE",
  VIEW_ALL_COMPANY_PIPELINE: "VIEW_ALL_COMPANY_PIPELINE",
  ADMIN: "ADMIN",
  UPLOAD_FILES: "UPLOAD_FILES",
  VIEW_PURCHASE_ADVICE: "VIEW_PURCHASE_ADVICE",
  VIEW_QUICKPRICER: "VIEW_QUICKPRICER",
});

/**
 * Inclusion (allow-list) model:
 *   Each persona maps to the permissions it IS allowed to perform.
 *   Access is GRANTED only when at least one of the user's personas
 *   includes the required permission. If the user has no matching
 *   persona — or none of their personas grants the permission —
 *   access is DENIED by default.
 */
export const PERSONA_INCLUSIONS = {
  "Corr - Full Access w/o PA": [
    PERMISSIONS.CREATE_LOANS,
    PERMISSIONS.LOCK_LOANS,
    PERMISSIONS.VIEW_PRICING,
    PERMISSIONS.VIEW_PIPELINE,
    PERMISSIONS.VIEW_ALL_COMPANY_PIPELINE,
    PERMISSIONS.UPLOAD_FILES,
  ],
  "Security Admin": [
    PERMISSIONS.CREATE_LOANS,
    PERMISSIONS.LOCK_LOANS,
    PERMISSIONS.VIEW_PRICING,
    PERMISSIONS.VIEW_PIPELINE,
    PERMISSIONS.VIEW_ALL_COMPANY_PIPELINE,
    PERMISSIONS.ADMIN,
    PERMISSIONS.UPLOAD_FILES,
    PERMISSIONS.VIEW_PURCHASE_ADVICE,
    PERMISSIONS.VIEW_QUICKPRICER,
  ],


  "Corr - Full Access": [
    PERMISSIONS.CREATE_LOANS,
    PERMISSIONS.LOCK_LOANS,
    PERMISSIONS.VIEW_PRICING,
    PERMISSIONS.VIEW_PIPELINE,
    PERMISSIONS.VIEW_ALL_COMPANY_PIPELINE,
    PERMISSIONS.UPLOAD_FILES,
    PERMISSIONS.VIEW_PURCHASE_ADVICE,
    PERMISSIONS.VIEW_QUICKPRICER,
  ],

  "Corr - Full Access w/o Pricing": [
    PERMISSIONS.CREATE_LOANS,
    PERMISSIONS.VIEW_PIPELINE,
    PERMISSIONS.VIEW_ALL_COMPANY_PIPELINE,
    PERMISSIONS.UPLOAD_FILES,
  ],

  "Corr - Pipeline & Resources": [
    PERMISSIONS.VIEW_PIPELINE,
    PERMISSIONS.VIEW_ALL_COMPANY_PIPELINE,
    PERMISSIONS.UPLOAD_FILES,
  ],

  "Corr - Resources Only": [],
};
